import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, useContext } from "@nuxtjs/composition-api";
import { getClientRuntimeConfig } from "~/core/helpers/GlobalHelpers";

interface Props {
    countdown: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Maintenance',
  props: {
    countdown: null
  },
  emits: ['end'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { countdown: number };




const { countdown } = toRefs(props);
const context = useContext();

const $config = getClientRuntimeConfig();
const currentColorMode = context.$colorMode;

const isXmasMode = computed(() => $config.xmasMode);
const currentColorModeValue = computed(() => {
    return currentColorMode.value || 'light';
})

return { __sfc: true,props, $emit, countdown, context, $config, currentColorMode, isXmasMode, currentColorModeValue }
}

})